module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d4/main_pc_4b9db4113379096a39239105e31d45c6.jpg";